import { ScrollText } from "lucide-react";

const Row = ({ label, value, highlight }) => (
  <div className="flex justify-between gap-3 py-1">
    <span className="text-zinc-400">{label}</span>
    <span className={`font-mono ${highlight ? "text-emerald-300" : "text-zinc-200"}`}>{value}</span>
  </div>
);

export const EffectiveRules = ({ rules }) => {
  if (!rules) return null;
  return (
    <div
      className="border border-zinc-800 bg-zinc-900/30 p-4 text-xs"
      data-testid="effective-rules-panel"
    >
      <div className="flex items-center gap-2 mb-3">
        <ScrollText className="h-4 w-4 text-emerald-500" />
        <h3 className="text-sm font-heading font-semibold tracking-tight">My Rules</h3>
        <span
          data-testid="rules-source-badge"
          className={`ml-auto px-1.5 py-0.5 rounded-sm text-[10px] uppercase font-semibold ${
            rules.has_override
              ? "bg-emerald-500/10 text-emerald-300"
              : "bg-zinc-800 text-zinc-400"
          }`}
        >
          {rules.has_override ? "custom" : "template"}
        </span>
      </div>
      <Row
        label="Risk per trade"
        value={
          rules.risk_method === "fixed"
            ? `$${Number(rules.risk_fixed_amount).toFixed(2)}`
            : `${rules.risk_percent}% of balance`
        }
        highlight
      />
      <Row label="Daily loss limit" value={`$${Number(rules.daily_loss_limit).toFixed(2)}`} />
      <Row
        label="Limit mode"
        value={rules.loss_limit_mode === "trailing" ? "grows with profit" : "fixed"}
      />
      <Row label="Max open trades" value={Number(rules.max_open_trades)} />
      <Row
        label="Max trades / day"
        value={Number(rules.max_trades_per_day) > 0 ? Number(rules.max_trades_per_day) : "unlimited"}
      />
      <Row
        label="Daily profit target"
        value={
          Number(rules.daily_profit_target) > 0
            ? `$${Number(rules.daily_profit_target).toFixed(2)}`
            : "off"
        }
      />
      <Row label="Trading window" value={`${rules.window_start}–${rules.window_end} IST`} />
      <Row label="TP1 closes" value={`${Number(rules.tp1_ratio)}%`} />
      <Row
        label="SL to break-even at TP1"
        value={rules.move_be_on_tp1 === false ? "Off" : "On"}
      />
      <Row
        label="Default R:R"
        value={`TP1 ${rules.tp1_r ?? 0}R · TP2 ${rules.tp2_r ?? 0}R`}
        highlight
      />
      <p className="text-[11px] text-zinc-400 mt-3 leading-relaxed">
        {rules.has_override
          ? "Your administrator set custom limits for your account."
          : "You are on the desk rule template set by your administrator."}
      </p>
    </div>
  );
};
